import script from "./ProtectionStrategy.vue?vue&type=script&setup=true&lang=js"
export * from "./ProtectionStrategy.vue?vue&type=script&setup=true&lang=js"

import "./ProtectionStrategy.vue?vue&type=style&index=0&id=050b543f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050b543f"]])

export default __exports__